// The promise on the landing page: up to three offers within 48 hours of the request arriving.
export const SLA_HOURS = 48

export function slaDueAt(createdAt: Date): Date {
  return new Date(createdAt.getTime() + SLA_HOURS * 60 * 60 * 1000)
}

export function euroToCents(euro: number): number {
  return Math.round(euro * 100)
}

// Stage 0-1 asks the booker for 8-12 % of the band's fee (BUSINESS_CASE.md section 6); 10 % is the middle.
// shortcut: one flat rate for every booking, make it per-request once the founder negotiates fees.
export const SERVICE_FEE_PERCENT = 10

export function serviceFeeCents(agreedPriceCents: number): number {
  return Math.round((agreedPriceCents * SERVICE_FEE_PERCENT) / 100)
}

export function centsToEuro(cents: number): string {
  return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })
}

/**
 * How much time is left on the 48 h promise, as something a human can read at a glance.
 * Pure on purpose - the admin list renders it on the server, and it is the one piece of this
 * feature worth a test.
 */
export function slaRemaining(dueAt: Date, now: Date = new Date()) {
  const ms = dueAt.getTime() - now.getTime()
  const overdue = ms < 0
  const totalMinutes = Math.floor(Math.abs(ms) / 60000)
  const hours = Math.floor(totalMinutes / 60)
  const minutes = totalMinutes % 60
  // under an hour the minutes are what matter; above it the minutes are noise
  const amount = hours > 0 ? `${hours} h ${minutes} min` : `${minutes} min`
  return {
    overdue,
    minutes: overdue ? -totalMinutes : totalMinutes,
    label: overdue ? `${amount} überfällig` : `noch ${amount}`,
  }
}

export const SLA_STALE_HOURS = 24
export const SLA_WARN_HOURS = 6
export type SlaStage = 'stale' | 'due_soon' | 'missed'

/**
 * Which founder reminder an open request needs right now (S0-020), or null. One stage at a time,
 * the most urgent one: a cron run that comes late jumps straight to "missed" instead of sending
 * a "due in 6 h" that is already untrue. "stale" means nobody touched it: status is still `new`.
 */
export function slaStage(
  request: { status: string; createdAt: Date; slaDueAt: Date },
  now: Date = new Date()
): SlaStage | null {
  if (request.status !== 'new' && request.status !== 'in_progress') return null
  const hour = 60 * 60 * 1000
  if (request.slaDueAt <= now) return 'missed'
  if (request.slaDueAt.getTime() - now.getTime() <= SLA_WARN_HOURS * hour) return 'due_soon'
  if (
    request.status === 'new' &&
    now.getTime() - request.createdAt.getTime() >= SLA_STALE_HOURS * hour
  )
    return 'stale'
  return null
}
